
import { defineComponent, onMounted, ref, toRefs } from 'vue'
export default defineComponent({
  name: 'BaseElScrollbar',
  props: {
    vertical: {
      type: Boolean,
      default: true
    },
    whellRoll: {
      type: Boolean,
      default: false
    },
    horiHeight: {
      type: [String, Number],
      default: '6'
    },
    vertWidth: {
      type: [String, Number],
      default: '6'
    }
  },
  setup (props) {
    const elScrollbarRef = ref()
    const { whellRoll } = toRefs(props)
    onMounted(() => {
      const elScrollbarWrap = elScrollbarRef.value.$el.getElementsByClassName('el-scrollbar__wrap')[0]
      elScrollbarWrap.style.marginBottom = '-9px'   
    })
    function wheelHandler (e: any) {
      if (whellRoll.value) {
        e.preventDefault()
        e.returnValue = false
        e.stopPropagation()
        e.cancelBubble = true
        const wrap = elScrollbarRef.value.$refs.wrap
        wrap.scrollLeft = wrap.scrollLeft - e.wheelDelta
      }
    }
    function setScrollTop (scrollTop: number) {
      elScrollbarRef.value.setScrollTop(scrollTop)
    }
    return {
      elScrollbarRef,
      wheelHandler,
      setScrollTop
    }
  }
})
